<template>
  <div class="system">
    <layout width="200px">
      <template v-slot:left>
        <publicMenu :list="list" iconUrl="list" :totalNum="totalNum"></publicMenu>
      </template>
      <template v-slot:right>
        <router-view></router-view>
      </template>
    </layout>
  </div>
</template>

<script>
import layout from "../../components/layout.vue";
import publicMenu from "../../components/publicMenu.vue";
export default {
  data() {
    return {
      totalNum: "",
      list: [],
    };
  },
  components: {
    layout,
    publicMenu,
  },
  watch: {
    $route(to, from) {
      // console.log(from.path) // 从哪来
      console.log(to.path); // 到哪去
      if (to.path == "/index/security") {
        this.$router.push(this.list[0].children[0].path);
      }
    },
  },
  methods: {
    getAll() {
      var a = JSON.parse(localStorage.getItem("cd"));
      console.log(a);
      a.forEach((val) => {
        if (val.meta.title == "安防") {
          var b = val.children;
          console.log(b);
          this.list = b;
          console.log(this.list);
        }
      });
      if (this.$route.path == "/index/security") {
        this.$router.push(this.list[0].children[0].path);
      }
      return;
      this.$http
        .get(
          `/api/api/findMenusByRoleIdAndPath?path=${this.$route.matched[1].path}&roleId=${sessionStorage.roleId}`
        )
        .then((res) => {
          this.list = res.data.data;
          this.$router.push(this.list[0].bdMenus[0].path);
        });
    },
    getNum() {
      this.$http
        .post(`/api/safe/securityIncident/pageQuery`, {
          pageSize: 1, //当前页
          pageNum: 10, //页大小
          status: false,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.data = res.data.rows;
            this.totalNum = res.data.total;
          }
        });
    },
  },
  mounted() {
    this.getAll();
    this.getNum();
  },
};
</script>

<style scoped="scoped"></style>
